import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

import { LinkContext } from "../LinkProvider";

function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const { link, loginLink } = useContext(LinkContext);
  const location = useLocation();
  const { t } = useTranslation();
  const navItems = [
    { to: "/aboutus", label: t("header.about") },
    { to: "/accounts", label: t("header.accounts") },
    { to: "/markets", label: t("header.markets") },
    { to: "/support", label: t("header.support") },
  ];

  return (
    <div>
      <button
        type="button"
        aria-label={isOpen ? "Close menu" : "Open menu"}
        onClick={() => setIsOpen(!isOpen)}
        className={`relative z-[999] flex h-[42px] w-[42px] items-center justify-center rounded-[12px] border transition-colors xl:hidden ${isOpen ? "border-white/35 bg-white/10" : "border-[#d8dfeb] bg-white shadow-[0_8px_24px_rgba(5,25,58,0.12)]"}`}
      >
        <span className="relative block h-[18px] w-[20px]">
          <span className={`absolute left-0 top-0 h-[2px] w-full rounded-full transition duration-300 ${isOpen ? "translate-y-[8px] rotate-45 bg-white" : "bg-[#071d42]"}`} />
          <span className={`absolute left-0 top-[8px] h-[2px] rounded-full transition duration-300 ${isOpen ? "w-0 opacity-0" : "w-full bg-[#071d42]"}`} />
          <span className={`absolute bottom-0 left-0 h-[2px] w-full rounded-full transition duration-300 ${isOpen ? "-translate-y-[8px] -rotate-45 bg-white" : "bg-[#071d42]"}`} />
        </span>
      </button>
      <div className={`fixed inset-0 z-40 bg-[#05193A]/35 backdrop-blur-[2px] transition-opacity duration-300 ${isOpen ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"}`} onClick={() => setIsOpen(false)} />
      <div className={`fixed inset-y-0 right-0 z-50 w-full bg-[#071d42] shadow-[-24px_0_80px_rgba(0,0,0,0.28)] transition-transform duration-300 md:w-1/2 ${isOpen ? "translate-x-0" : "translate-x-full"}`}>
   
        <nav className="mt-[96px] flex flex-col items-center gap-[18px]">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              onClick={() => setIsOpen(false)}
              className={`font-[Poppins] text-[18px] text-white ${location.pathname === item.to ? "font-bold" : "font-medium"}`}
            >
              {item.label}
            </Link>
          ))}
        </nav>
        <div className="mt-[42px] flex flex-col items-center gap-[16px]">
          <a
            href={loginLink}
            onClick={() => setIsOpen(false)}
            className="inline-flex h-[42.386px] min-w-[190px] items-center justify-center gap-[10px] rounded-[10px] bg-white px-[35px] py-[12px] text-center font-[Inter] text-[16px] font-light capitalize leading-normal text-[#05193A]"
          >
            {t("header.login")}
          </a>
          <a
            href={link}
            onClick={() => setIsOpen(false)}
            className="inline-flex h-[42.386px] min-w-[190px] items-center justify-center gap-[10px] rounded-[10px] border border-white px-[35px] py-[12px] text-center font-[Inter] text-[16px] font-light capitalize leading-normal text-white"
          >
            {t("header.openAccount")}
          </a>
        </div>
      </div>
    </div>
  );
}

export default MobileMenu;
